import {styled} from "@mui/material/styles";
import {Box, Typography} from "@mui/material";
import {sidebarWidth} from "./app-layout";

export const PageContainer = styled(Box, {shouldForwardProp: prop => prop !== "navOpen"})(({theme, navOpen}) => ({
    boxSizing: "border-box",
    flex: "0 1 auto",
    minWidth: 0,
    width: "100%",
    marginLeft: 0,
    padding: theme.spacing(2),
    "& .MuiGrid-item": {minWidth: 0},
    "& .MuiTypography-root": {overflowWrap: "anywhere"},
    "& .MuiTableContainer-root": {maxWidth: "100%", overflowX: "auto"},
    [theme.breakpoints.up("sm")]: {
        width: `calc(100% - ${sidebarWidth(navOpen)}px)`,
        marginLeft: sidebarWidth(navOpen),
    },
    [theme.breakpoints.up("md")]: {padding: theme.spacing(3)},
    [theme.breakpoints.up("lg")]: {padding: theme.spacing(4)},
}))

export const PageTitle = styled(Typography)(({theme}) => ({
    fontFamily: "Roboto",
    fontWeight: 400,
    fontSize: "clamp(1.75rem, 5vw, 2.125rem)",
    lineHeight: 1.24,
    letterSpacing: "0.01em",
    marginBottom: theme.spacing(2),
}))

export const PaginationContainer = styled(Box)(({theme}) => ({
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(2),
}))
